import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
const calcMinWidth = (cardWidth, numberOfTiers)=>`calc(${cardWidth}px * ${numberOfTiers} + 16px * ${numberOfTiers - 1})`;
const PAGE_WIDTH_1440_CARD_WIDTH = 240;
const PAGE_WIDTH_1440_CARD_WIDTH_NEW_PRICING = 300;
const PAGE_WIDTH_1920_CARD_WIDTH = 304;
const PAGE_WIDTH_2_CARDS_WIDTH = 320;
const old_calcMinWidth1440 = (isNewPricing)=>`calc(${isNewPricing ? PAGE_WIDTH_1440_CARD_WIDTH_NEW_PRICING : PAGE_WIDTH_1440_CARD_WIDTH}px * 5 + 16px * 4)`;
const old_calcMinWidth1920 = `calc(${PAGE_WIDTH_1920_CARD_WIDTH}px * 5 + 16px * 4)`;
const calcMinWidth1440 = (numberOfTiers, isNewPricing)=>{
    const baseWidth = numberOfTiers === 2 ? PAGE_WIDTH_2_CARDS_WIDTH : isNewPricing ? PAGE_WIDTH_1440_CARD_WIDTH_NEW_PRICING : PAGE_WIDTH_1440_CARD_WIDTH;
    return calcMinWidth(baseWidth, numberOfTiers);
};
const calcMinWidth1920 = (numberOfTiers)=>{
    return calcMinWidth(PAGE_WIDTH_1920_CARD_WIDTH, numberOfTiers);
};
export const StyledProductPriceAndFeaturesCards = styled.div`
  width: ${({ isNewPricing })=>{
    const baseWidth = isNewPricing ? 240 : 216;
    return `calc(${baseWidth}px * 5 + 16px * 4)`;
}};
  max-width: calc(100% - 32px);
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  .seats-and-period-selection {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
  }

  .tiers {
    display: grid;
    justify-content: center;
    column-gap: 16px;
    grid-template-columns: ${({ numberOfTiers })=>`repeat(${numberOfTiers},1fr)`};
  }

  .tiers-mobile {
    display: none;
  }
  &.is-homepage-pricing {
    .seats-and-period-selection {
      padding-bottom: 0px;
    }
  }

  @media only screen and (min-width: 1440px) {
    width: ${({ isNewPricing })=>old_calcMinWidth1440(isNewPricing)};

    &.is-homepage-pricing {
      width: ${({ numberOfTiers, isNewPricing })=>calcMinWidth1440(numberOfTiers, isNewPricing)};
    }
  }

  @media only screen and (min-width: 1920px) {
    width: ${old_calcMinWidth1920};

    &.is-homepage-pricing {
      width: ${({ numberOfTiers })=>calcMinWidth1920(numberOfTiers)};
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    width: 100%;
    max-width: 100%;
    overflow-x: none;
    .tiers {
      display: none;
      &.tiers-mobile {
        display: block;
        width: 100%;
      }
    }
    .seats-and-period-selection {
      display: flex;
      row-gap: 12px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
`;
